// Mirrors backend shooting-schedule.effectiveWorkingHours: null inherits; zero is an override.
export const effectiveWorkingHours = (day, settings) => Number(day?.workingHours ?? settings?.hoursPerDay ?? 10);